import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  structuredData,
  canonicalUrl,
  hreflang
}) => {
  const siteUrl = 'https://www.viketory.it';
  const defaultImage = `${siteUrl}/favicon.png`; // Logo Viketory invece della bici
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image ? (image.startsWith('http') ? image : `${siteUrl}${image}`) : defaultImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Viketory E-Bike" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Italian" />
      <meta name="author" content="FreeWheel Store" />
      <meta name="geo.region" content="IT-NA" />
      <meta name="geo.placename" content="Castellammare di Stabia" />
      <meta name="geo.position" content="40.6944;14.4903" />
      <meta name="ICBM" content="40.6944, 14.4903" />
      
      {/* hreflang for multi-language support */}
      {hreflang ? (
        <>
          <link rel="alternate" hreflang="it" href={hreflang.it || fullUrl} />
          <link rel="alternate" hreflang="en" href={hreflang.en || fullUrl} />
          <link rel="alternate" hreflang="es" href={hreflang.es || fullUrl} />
          <link rel="alternate" hreflang="x-default" href={fullUrl} />
        </>
      ) : (
        <>
          <link rel="alternate" hreflang="it" href={fullUrl} />
          <link rel="alternate" hreflang="x-default" href={fullUrl} />
        </>
      )}
      
      {/* Structured Data */}
      {structuredData && (
        Array.isArray(structuredData) ? (
          structuredData.map((data, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(data)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )
      )}
    </Helmet>
  );
};

export default SEO;
